import { render } from "./StaffProfile.vue?vue&type=template&id=933e3c26"
import script from "./StaffProfile.vue?vue&type=script&lang=js"
export * from "./StaffProfile.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/menejar/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__